import React from "react";
import { Link } from "react-router-dom";
import Template from "../components/Template";
import HeroSlider from "../components/HeroSlider";
import Testimonials from "../components/Testimonials";
import CTA from "../components/CTA";
import Pricing from "../components/Pricing";

function Home() {
  return (
    <Template>
      <HeroSlider />

      {/* Marquee Start */}
      <section className="pbmit-marquee-effect-section">
        <div className="pbmit-marquee-inner pbminfotech-element-marquee-effect">
          <div className="pbmit-tag-top">
            <div className="swiper-slider marquee">
              <div className="swiper-wrapper">
                <div className="swiper-slide">
                  <article className="pbmit-marquee-effect-style-1">
                    <div className="pbmit-tag-wrapper">
                      <h2 className="pbmit-element-title">Online Training</h2>
                    </div>
                  </article>
                </div>
                <div className="swiper-slide">
                  <article className="pbmit-marquee-effect-style-1">
                    <div className="pbmit-tag-wrapper">
                      <h2 className="pbmit-element-title">
                        Daily Nutrition Tracking
                      </h2>
                    </div>
                  </article>
                </div>
                <div className="swiper-slide">
                  <article className="pbmit-marquee-effect-style-1">
                    <div className="pbmit-tag-wrapper">
                      <h2 className="pbmit-element-title">Performance Coach</h2>
                    </div>
                  </article>
                </div>
                <div className="swiper-slide">
                  <article className="pbmit-marquee-effect-style-1">
                    <div className="pbmit-tag-wrapper">
                      <h2 className="pbmit-element-title">Group Classes</h2>
                    </div>
                  </article>
                </div>
                <div className="swiper-slide">
                  <article className="pbmit-marquee-effect-style-1">
                    <div className="pbmit-tag-wrapper">
                      <h2 className="pbmit-element-title">
                        Personalized Workouts
                      </h2>
                    </div>
                  </article>
                </div>
                <div className="swiper-slide">
                  <article className="pbmit-marquee-effect-style-1">
                    <div className="pbmit-tag-wrapper">
                      <h2 className="pbmit-element-title">Online Training</h2>
                    </div>
                  </article>
                </div>
                <div className="swiper-slide">
                  <article className="pbmit-marquee-effect-style-1">
                    <div className="pbmit-tag-wrapper">
                      <h2 className="pbmit-element-title">
                        AI Workout Schedule
                      </h2>
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </div>
          <div className="pbmit-tag-bottom">
            <div className="swiper-slider marquee" data-reverse="true">
              <div className="swiper-wrapper">
                <div className="swiper-slide">
                  <article className="pbmit-marquee-effect-style-1">
                    <div className="pbmit-tag-wrapper">
                      <h2 className="pbmit-element-title">Online Training</h2>
                    </div>
                  </article>
                </div>
                <div className="swiper-slide">
                  <article className="pbmit-marquee-effect-style-1">
                    <div className="pbmit-tag-wrapper">
                      <h2 className="pbmit-element-title">
                        Daily Nutrition Tracking
                      </h2>
                    </div>
                  </article>
                </div>
                <div className="swiper-slide">
                  <article className="pbmit-marquee-effect-style-1">
                    <div className="pbmit-tag-wrapper">
                      <h2 className="pbmit-element-title">
                        AI Workout Schedule
                      </h2>
                    </div>
                  </article>
                </div>
                <div className="swiper-slide">
                  <article className="pbmit-marquee-effect-style-1">
                    <div className="pbmit-tag-wrapper">
                      <h2 className="pbmit-element-title">Group Classes</h2>
                    </div>
                  </article>
                </div>
                <div className="swiper-slide">
                  <article className="pbmit-marquee-effect-style-1">
                    <div className="pbmit-tag-wrapper">
                      <h2 className="pbmit-element-title">
                        Personalized Workouts
                      </h2>
                    </div>
                  </article>
                </div>
                <div className="swiper-slide">
                  <article className="pbmit-marquee-effect-style-1">
                    <div className="pbmit-tag-wrapper">
                      <h2 className="pbmit-element-title">Online Training</h2>
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Marquee End */}

      {/* Ihbox Start */}
      <section className="ihbox-section-one">
        <div className="container">
          <div
            className="pbmit-heading-subheading animation-style1"
            style={{ textAlign: "center", marginBottom: "50px" }}
          >
            <h4 className="pbmit-subtitle">
              <span></span>System Overview
            </h4>
            <h2 className="pbmit-title">One System. Two Journeys.</h2>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div
                className="pbmit-ihbox pbmit-ihbox-style-7 p-2"
                style={{ border: "1px solid white", borderRadius: "15px" }}
              >
                <div className="pbmit-ihbox-box">
                  <div className="pbmit-ihbox-headingicon">
                    <div className="row">
                      <div className="pbmit-ihbox-icon col-12 col-md-2">
                        <img
                          src="https://cdn-icons-png.flaticon.com/128/3043/3043888.png"
                          style={{
                            width: "80px",
                            height: "auto",
                            filter: "brightness(0) invert(1)",
                          }}
                        />
                      </div>
                      <div className="pbmit-ihbox-contents  col-12 col-md-10">
                        <h2 className="pbmit-element-title">
                          Fitness & Health
                        </h2>
                        <div className="pbmit-heading-desc">
                          Build strength, endurance, and overall wellness
                          through structured workouts designed to improve daily
                          performance. Stay consistent and feel stronger every
                          day.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div
                className="pbmit-ihbox pbmit-ihbox-style-7 p-2"
                style={{ border: "1px solid white", borderRadius: "15px" }}
              >
                <div className="pbmit-ihbox-box">
                  <div className="pbmit-ihbox-headingicon">
                    <div className="row">
                      <div className="pbmit-ihbox-icon col-12 col-md-2">
                        <img
                          src="https://cdn-icons-png.flaticon.com/128/11113/11113844.png"
                          style={{
                            width: "80px",
                            height: "auto",
                            filter: "brightness(0) invert(1)",
                          }}
                        />
                      </div>
                      <div className="pbmit-ihbox-contents  col-12 col-md-10">
                        <h2 className="pbmit-element-title">Performance</h2>
                        <div className="pbmit-heading-desc">
                          Transform your energy into focus and results. Improve
                          discipline, mental clarity, and physical output
                          through guided training and performance based
                          routines.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Ihbox End */}

      {/* Ihbox Start */}
      <section className="ihbox-section-one">
        <div className="container">
          <div
            className="pbmit-heading-subheading animation-style1"
            style={{ textAlign: "center", marginBottom: "50px" }}
          >
            <h4 className="pbmit-subtitle">
              <span></span>Health Journey Preview
            </h4>
            <h2 className="pbmit-title">Start with your body</h2>
          </div>
          <div className="row">
            <div className="col-md-6 py-4">
              <div className="pbmit-ihbox pbmit-ihbox-style-7">
                <div className="pbmit-ihbox-box">
                  <div className="pbmit-ihbox-headingicon">
                    <div className="pbmit-ihbox-contents">
                      <h2 className="pbmit-element-title">
                        Personalized Workouts
                      </h2>
                      <div
                        className="pbmit-heading-desc"
                        style={{ textAlign: "justify" }}
                      >
                        Get customized workout plans designed around your
                        fitness level, body type, and goals. Whether you want to
                        lose weight, build strength, or improve endurance, our
                        programs adapt to keep you motivated and injury free.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 py-4">
              <div className="pbmit-ihbox pbmit-ihbox-style-7">
                <div className="pbmit-ihbox-box">
                  <div className="pbmit-ihbox-headingicon">
                    <div className="pbmit-ihbox-contents">
                      <h2 className="pbmit-element-title">
                        Smart Nutrition Tracking
                      </h2>
                      <div
                        className="pbmit-heading-desc"
                        style={{ textAlign: "justify" }}
                      >
                        Track your daily meals, hydration, and calories with
                        ease. Our nutrition guidance helps you make smarter food
                        choices, stay consistent, and support your fitness goals
                        without extreme dieting.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 py-4">
              <div className="pbmit-ihbox pbmit-ihbox-style-7">
                <div className="pbmit-ihbox-box">
                  <div className="pbmit-ihbox-headingicon">
                    <div className="pbmit-ihbox-contents">
                      <h2 className="pbmit-element-title">
                        AI-Guided Training
                      </h2>
                      <div
                        className="pbmit-heading-desc"
                        style={{ textAlign: "justify" }}
                      >
                        Experience intelligent workout guidance that adapts to
                        your performance, recovery, and progress. Our AI system
                        ensures every session is effective, safe, and tailored
                        to your needs.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 py-4">
              <div className="pbmit-ihbox pbmit-ihbox-style-7">
                <div className="pbmit-ihbox-box">
                  <div className="pbmit-ihbox-headingicon">
                    <div className="pbmit-ihbox-contents">
                      <h2 className="pbmit-element-title">
                        1:1 & Group Coaching
                      </h2>
                      <div
                        className="pbmit-heading-desc"
                        style={{ textAlign: "justify" }}
                      >
                        Get expert guidance through one-on-one coaching or stay
                        motivated with group sessions led by certified trainers
                        who keep you focused, accountable, and progressing every
                        step of the way.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="text-center mt-5">
              <Link to="/fitness#pricing" className="pbmit-btn pbmit-btn-white">
                View Fitness Plans
              </Link>
            </div>
          </div>
        </div>
      </section>
      {/* Ihbox End */}

      {/* Portfolio Start */}
      <section className="portfolio-bg-one">
        <div className="container">
          <div className="row">
            <div className="col-xl-8 col-md-12">
              <div className="pbmit-heading-subheading text-white animation-style1">
                <h4 className="pbmit-subtitle">
                  <span></span>Performance Bridge
                </h4>
                <h2 className="pbmit-title">
                  Your body powers your performance
                </h2>
              </div>
            </div>
            <div className="col-xl-4 col-md-12">
              <div className="portfolio-button">
                <Link to="/performance" className="pbmit-btn">
                  <span className="button-text">
                    See Performance Development
                  </span>
                </Link>
              </div>
            </div>
          </div>
          <div class="row pbmit-element-portfolio-style-2">
            <article class="pbmit-ele pbmit-portfolio-style-2 col-md-4">
              <div class="pbminfotech-post-content">
                <div class="pbminfotech_portfolio-featured-wrapper">
                  <div class="pbmit-featured-img-wrapper">
                    <div class="pbmit-featured-wrapper">
                      <img
                        src="assets/images/daily/v5.jpg"
                        class="img-fluid"
                        alt="Energy and Fitness"
                      />
                    </div>
                  </div>
                  <div class="pbmit-port-cat">
                    <a rel="tag">Energy & Fitness</a>
                  </div>
                </div>
                <div class="pbminfotech-box-content">
                  <div class="pbminfotech-titlebox">
                    <h3 class="pbmit-portfolio-title mb-2">
                      <a>Energy Drives Focus</a>
                    </h3>
                    <p class="pbmit-portfolio-desc text-dark">
                      Building consistent energy through movement and structured
                      training improves focus, mental clarity, and day-to-day
                      performance.
                    </p>
                  </div>
                </div>
              </div>
            </article>

            <article class="pbmit-ele pbmit-portfolio-style-2 col-md-4">
              <div class="pbminfotech-post-content">
                <div class="pbminfotech_portfolio-featured-wrapper">
                  <div class="pbmit-featured-img-wrapper">
                    <div class="pbmit-featured-wrapper">
                      <img
                        src="assets/images/daily/v1 (5).png"
                        class="img-fluid"
                        alt="Habits and Consistency"
                      />
                    </div>
                  </div>
                  <div class="pbmit-port-cat">
                    <a rel="tag">Habits & Consistency</a>
                  </div>
                </div>
                <div class="pbminfotech-box-content">
                  <div class="pbminfotech-titlebox">
                    <h3 class="pbmit-portfolio-title mb-2">
                      <a>Habits Shape Execution</a>
                    </h3>
                    <p class="pbmit-portfolio-desc text-dark">
                      Simple daily routines and intentional nutrition choices
                      build discipline, consistency, and long term progress
                      toward meaningful goals.
                    </p>
                  </div>
                </div>
              </div>
            </article>

            <article class="pbmit-ele pbmit-portfolio-style-2 col-md-4">
              <div class="pbminfotech-post-content">
                <div class="pbminfotech_portfolio-featured-wrapper">
                  <div class="pbmit-featured-wrapper">
                    <img
                      src="assets/images/daily/2.png"
                      class="img-fluid"
                      alt="Recovery and Performance"
                    />
                  </div>
                  <div class="pbmit-port-cat">
                    <a rel="tag">Regulation & Performance</a>
                  </div>
                </div>
                <div class="pbminfotech-box-content">
                  <div class="pbmit-titlebox">
                    <h3 class="pbmit-portfolio-title mb-2">
                      <a>Regulation Improves Decision Quality</a>
                    </h3>
                    <p class="pbmit-portfolio-desc text-dark">
                      Intentional recovery and nervous system regulation reduce
                      fatigue, restore clarity, and support better decisions so
                      performance stays consistent without burnout.
                    </p>
                  </div>
                </div>
              </div>
            </article>
          </div>
        </div>
      </section>

      <section className="section-lg pbmit-element-miconheading-style-2 overflow-hidden">
        <div className="container">
          <div className="pbmit-heading-subheading text-center animation-style1">
            <h4 className="pbmit-subtitle">
              <span></span>Our Classes
            </h4>
            <h2 className="pbmit-title">AVAILABLE CLASSES</h2>
          </div>
          <div className="row pbmit-posts-wrapper">
            <article className="pbmit-ele pbmit-miconheading-style-2 col-md-12">
              <div className="pbmit-ihbox pbmit-ihbox-style-2">
                <div className="pbmit-ihbox-box">
                  <div className="pbmit-ihbox-box-wrap d-flex justify-content-between align-items-center">
                    <h2 className="pbmit-element-title">
                      <Link to="hit" rel="noreferrer">
                        HIT (High Intensity Training)
                      </Link>
                    </h2>
                    <h4 className="pbmit-element-subtitle">
                      Available in all plans
                    </h4>
                    <div
                      className="pbmit-hover-img"
                      style={{
                        transform: "translate(95px, 65px) scale(0.4, 0.4)",
                        opacity: 0,
                      }}
                    ></div>
                    <Link className="pbmit-svg-btn" to="hit">
                      <svg
                        className="pbmit-svg-arrow"
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        width="10"
                        height="19"
                        viewBox="0 0 19 19"
                      >
                        <line x1="1" y1="18" x2="17.8" y2="1.2"></line>
                        <line x1="1.2" y1="1" x2="18" y2="1"></line>
                        <line x1="18" y1="17.8" x2="18" y2="1"></line>
                      </svg>
                    </Link>
                  </div>
                </div>
              </div>
            </article>
            <article className="pbmit-ele pbmit-miconheading-style-2 col-md-12">
              <div className="pbmit-ihbox pbmit-ihbox-style-2">
                <div className="pbmit-ihbox-box">
                  <div className="pbmit-ihbox-box-wrap d-flex justify-content-between align-items-center">
                    <h2 className="pbmit-element-title">
                      <Link to="dance" rel="noreferrer">
                        DANCE
                      </Link>
                    </h2>
                    <h4 className="pbmit-element-subtitle">
                      Available in all plans
                    </h4>
                    <div
                      className="pbmit-hover-img"
                      style={{
                        transform: "translate(95px, 65px) scale(0.4, 0.4)",
                        opacity: 0,
                      }}
                    ></div>
                    <Link className="pbmit-svg-btn" to="dance">
                      <svg
                        className="pbmit-svg-arrow"
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        width="10"
                        height="19"
                        viewBox="0 0 19 19"
                      >
                        <line x1="1" y1="18" x2="17.8" y2="1.2"></line>
                        <line x1="1.2" y1="1" x2="18" y2="1"></line>
                        <line x1="18" y1="17.8" x2="18" y2="1"></line>
                      </svg>
                    </Link>
                  </div>
                </div>
              </div>
            </article>
            <article className="pbmit-ele pbmit-miconheading-style-2 col-md-12">
              <div className="pbmit-ihbox pbmit-ihbox-style-2">
                <div className="pbmit-ihbox-box">
                  <div className="pbmit-ihbox-box-wrap d-flex justify-content-between align-items-center">
                    <h2 className="pbmit-element-title">
                      <Link to="yoga" rel="noreferrer">
                        YOGA
                      </Link>
                    </h2>
                    <h4 className="pbmit-element-subtitle">
                      Available in all plans
                    </h4>
                    <div
                      className="pbmit-hover-img"
                      style={{
                        transform: "translate(95px, 65px) scale(0.4, 0.4)",
                        opacity: 0,
                      }}
                    ></div>
                    <Link className="pbmit-svg-btn" to="yoga">
                      <svg
                        className="pbmit-svg-arrow"
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        width="10"
                        height="19"
                        viewBox="0 0 19 19"
                      >
                        <line x1="1" y1="18" x2="17.8" y2="1.2"></line>
                        <line x1="1.2" y1="1" x2="18" y2="1"></line>
                        <line x1="18" y1="17.8" x2="18" y2="1"></line>
                      </svg>
                    </Link>
                  </div>
                </div>
              </div>
            </article>
            <article className="pbmit-ele pbmit-miconheading-style-2 col-md-12">
              <div className="pbmit-ihbox pbmit-ihbox-style-2">
                <div className="pbmit-ihbox-box">
                  <div className="pbmit-ihbox-box-wrap d-flex justify-content-between align-items-center">
                    <h2 className="pbmit-element-title">
                      <Link to="group-classes" rel="noreferrer">
                        GROUP CLASSES
                      </Link>
                    </h2>
                    <h4 className="pbmit-element-subtitle">
                      12-Month Plan Only
                    </h4>
                    <div
                      className="pbmit-hover-img"
                      style={{
                        transform: "translate(95px, 65px) scale(0.4, 0.4)",
                        opacity: 0,
                      }}
                    ></div>
                    <Link className="pbmit-svg-btn" to="group-classes">
                      <svg
                        className="pbmit-svg-arrow"
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        width="10"
                        height="19"
                        viewBox="f0 0 19 19"
                      >
                        <line x1="1" y1="18" x2="17.8" y2="1.2"></line>
                        <line x1="1.2" y1="1" x2="18" y2="1"></line>
                        <line x1="18" y1="17.8" x2="18" y2="1"></line>
                      </svg>
                    </Link>
                  </div>
                </div>
              </div>
            </article>
          </div>
        </div>
      </section>
      {/* Our Classes End */}

      <section className="bg-white pbminfotech-ele-ptable-style-1 pbmit-text-color-blackish">
        <div className="container">
          <div className="pbmit-heading-subheading text-white text-center animation-style1">
            <h4 className="pbmit-subtitle">
              <span></span>The System
            </h4>
            <h2 className="pbmit-title">The System (Not a Course)</h2>
            <p className="text-dark">
              <b>
                This isn’t something you watch. It’s something you live daily.
              </b>
            </p>
          </div>

          <div className="row">
            {/* Beginner Plan */}
            <div className="pbmit-ptable-col col-lg-4 col-md-6 col-sm-12">
              <div className="pbmit-pricing-table-box">
                <img
                  src="assets/images/daily/5.png"
                  style={{ width: "100%" }}
                />
                <div className="pbmit-heading-box">
                  <div className="pbminfotech-ptable-frequency">Step 1</div>
                  <div className="pbmit-head-wrap">
                    <div className="pbminfotech-ptable-price-w">
                      <h3 className="pbminfotech-ptable-heading">
                        Physical Foundation
                      </h3>
                      <div className="pbminfotech-sep"></div>
                      <p>
                        Develop the physical capacity required for clear
                        thinking, emotional regulation, and sustainable
                        performance.
                      </p>
                    </div>
                    <div className="pbmit-ptable-icon">
                      <div className="pbmit-ptable-icon-wrapper">
                        <div className="pbmit-icon-wrapper pbmit-icon-type-icon">
                          <i className="pbmit-gyim-icon pbmit-gyim-icon-sneaker"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Premium Plan */}
            <div className="pbmit-pricing-table-featured-col pbmit-ptable-col col-lg-4 col-md-6 col-sm-12">
              <div className="pbmit-pricing-table-box">
                <img
                  src="assets/images/daily/v1 (5).png"
                  style={{ width: "100%" }}
                />
                <div className="pbmit-ptablebox-featured-w"></div>
                <div className="pbmit-heading-box">
                  <div className="pbminfotech-ptable-frequency">Step 2</div>
                  <div className="pbmit-head-wrap">
                    <div className="pbminfotech-ptable-price-w">
                      <h3 className="pbminfotech-ptable-heading">
                        Daily Discipline
                      </h3>
                      <div className="pbminfotech-sep"></div>
                      <p>
                        Establish routines and systems that protect focus,
                        reduce noise, and create consistent execution.
                      </p>
                      <br />
                    </div>
                    <div className="pbmit-ptable-icon">
                      <div className="pbmit-ptable-icon-wrapper">
                        <div className="pbmit-icon-wrapper pbmit-icon-type-icon">
                          <i className="pbmit-gyim-icon pbmit-gyim-icon-pulsometer"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Ultimate Plan */}
            <div className="pbmit-ptable-col col-lg-4 col-md-6 col-sm-12">
              <div className="pbmit-pricing-table-box">
                <img
                  src="assets/images/daily/1.png"
                  style={{ width: "100%" }}
                />
                <div className="pbmit-heading-box">
                  <div className="pbminfotech-ptable-frequency">Step 3</div>
                  <div className="pbmit-head-wrap">
                    <div className="pbminfotech-ptable-price-w">
                      <h3 className="pbminfotech-ptable-heading">
                        Performance Application
                      </h3>
                      <div className="pbminfotech-sep"></div>
                      <p>
                        Coach led application of focus, execution, and decision
                        quality into work, leadership, and life under pressure.
                      </p>
                    </div>
                    <div className="pbmit-ptable-icon">
                      <div className="pbmit-ptable-icon-wrapper">
                        <div className="pbmit-icon-wrapper pbmit-icon-type-icon">
                          <i className="pbmit-gyim-icon pbmit-gyim-icon-dumbbells"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="team-details-section">
        <div className="container">
          <div className="pbmit-heading-subheading text-center animation-style1">
            <h4 className="pbmit-subtitle">
              <span></span> Do / Don’ts
            </h4>
            <h2 className="pbmit-title">Do / Don’ts</h2>
          </div>
          <div className="row g-3">
            <div className="col-12">
              <div className="team-progress pt-0">
                <div className="row">
                  {/* DOs Section */}
                  <div
                    className="col-md-6 team-info"
                    style={{ backgroundColor: "#47B648", padding: "40px 25px" }}
                  >
                    <h4
                      className="pbmit-title"
                      style={{ textTransform: "capitalize" }}
                    >
                      DO's{" "}
                      <img
                        src="https://cdn-icons-png.flaticon.com/128/18045/18045536.png"
                        style={{
                          width: "45px",
                          height: "45px",
                          filter: "brightness(0) invert(1)",
                        }}
                      />
                    </h4>
                    <p>
                      Follow these healthy habits to get the best results from
                      your fitness routine and stay consistent.
                    </p>

                    <ul className="pbmit-blog-list-ele mb-0">
                      <li>
                        <i
                          className="pbmit-base-icon-check"
                          style={{ color: "white" }}
                        ></i>{" "}
                        Warm up properly before every workout
                      </li>
                      <li>
                        <i
                          className="pbmit-base-icon-check"
                          style={{ color: "white" }}
                        ></i>{" "}
                        Maintain correct posture and form
                      </li>
                      <li>
                        <i
                          className="pbmit-base-icon-check"
                          style={{ color: "white" }}
                        ></i>{" "}
                        Stay hydrated throughout the day
                      </li>
                      <li>
                        <i
                          className="pbmit-base-icon-check"
                          style={{ color: "white" }}
                        ></i>{" "}
                        Follow a balanced nutrition plan
                      </li>
                      <li>
                        <i
                          className="pbmit-base-icon-check"
                          style={{ color: "white" }}
                        ></i>{" "}
                        Warm down and stretch after workouts
                      </li>
                      <li>
                        <i
                          className="pbmit-base-icon-check"
                          style={{ color: "white" }}
                        ></i>{" "}
                        Listen to your body and rest when needed
                      </li>
                      <li>
                        <i
                          className="pbmit-base-icon-check"
                          style={{ color: "white" }}
                        ></i>{" "}
                        Track your progress and stay consistent
                      </li>
                      <li>
                        <i
                          className="pbmit-base-icon-check"
                          style={{ color: "white" }}
                        ></i>{" "}
                        Maintain proper breathing during exercises
                      </li>
                      <li>
                        <i
                          className="pbmit-base-icon-check"
                          style={{ color: "white" }}
                        ></i>{" "}
                        Stay disciplined with your workout schedule
                      </li>
                      <li>
                        <i
                          className="pbmit-base-icon-check"
                          style={{ color: "white" }}
                        ></i>{" "}
                        Focus on long term health over quick results
                      </li>
                    </ul>
                  </div>

                  {/* DON'Ts Section */}
                  <div
                    className="col-md-6 team-info"
                    style={{ backgroundColor: "#E91D26", padding: "40px 25px" }}
                  >
                    <h4
                      className="pbmit-title"
                      style={{ textTransform: "capitalize" }}
                    >
                      DON'Ts{" "}
                      <img
                        src="https://cdn-icons-png.flaticon.com/128/4926/4926589.png"
                        style={{
                          width: "45px",
                          height: "45px",
                          filter: "brightness(0) invert(1)",
                        }}
                      />
                    </h4>
                    <p>
                      Avoid these common mistakes to prevent injuries and ensure
                      long term progress.
                    </p>

                    <ul className="pbmit-blog-list-ele mb-0">
                      <li>
                        <i
                          className="pbmit-base-icon-cancel"
                          style={{ color: "white" }}
                        ></i>{" "}
                        Skip warm up or cool down sessions
                      </li>
                      <li>
                        <i
                          className="pbmit-base-icon-cancel"
                          style={{ color: "white" }}
                        ></i>{" "}
                        Overtrain without proper recovery
                      </li>
                      <li>
                        <i
                          className="pbmit-base-icon-cancel"
                          style={{ color: "white" }}
                        ></i>{" "}
                        Ignore pain or push through injuries
                      </li>
                      <li>
                        <i
                          className="pbmit-base-icon-cancel"
                          style={{ color: "white" }}
                        ></i>{" "}
                        Follow random workout trends blindly
                      </li>
                      <li>
                        <i
                          className="pbmit-base-icon-cancel"
                          style={{ color: "white" }}
                        ></i>{" "}
                        Skip hydration during workouts
                      </li>
                      <li>
                        <i
                          className="pbmit-base-icon-cancel"
                          style={{ color: "white" }}
                        ></i>{" "}
                        Compare your progress with others
                      </li>
                      <li>
                        <i
                          className="pbmit-base-icon-cancel"
                          style={{ color: "white" }}
                        ></i>{" "}
                        Neglect proper sleep and recovery
                      </li>
                      <li>
                        <i
                          className="pbmit-base-icon-cancel"
                          style={{ color: "white" }}
                        ></i>{" "}
                        Rush results or overtrain muscles
                      </li>
                      <li>
                        <i
                          className="pbmit-base-icon-cancel"
                          style={{ color: "white" }}
                        ></i>{" "}
                        Ignore professional guidance when needed
                      </li>
                      <li>
                        <i
                          className="pbmit-base-icon-cancel"
                          style={{ color: "white" }}
                        ></i>{" "}
                        Quit after short term setbacks
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <hr />

      <Pricing />

      <hr />
      {/* Calculate End */}

      {/* Testimonial Start */}
      <section className="section-lgx">
        <Testimonials />
      </section>

      <section className="section-lgx" id="clarity-call">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-7">
              <form
                className="contact-form"
                method="post"
                id="contact-form"
                action="https://gyim-demo.pbminfotech.com/html-demo/send-dummy.php"
              >
                <h4>Book a Clarity Call</h4>
                <div className="row">
                  <div className="col-md-12">
                    <p>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Name"
                        name="name"
                        required
                      />
                    </p>
                  </div>

                  <div className="col-md-12">
                    <p>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Email"
                        name="email"
                        required
                      />
                    </p>
                  </div>

                  <div className="col-md-12">
                    <p>
                      <input
                        type="tel"
                        className="form-control"
                        placeholder="Phone"
                        name="number"
                        required
                      />
                    </p>
                  </div>

                  <div className="col-lg-12">
                    <button
                      type="submit"
                      className="pbmit-btn pbmit-btn-white pbmit-submit-btn"
                    >
                      <i className="form-btn-loader fa fa-circle-o-notch fa-spin fa-fw margin-bottom d-none" />
                      <span className="button-text">Send a message</span>
                    </button>
                  </div>

                  <div className="col-md-12 col-lg-12 message-status" />
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
      {/* Testimonial End */}

      <CTA
        subtitle="Start Your Transformation"
        title="Your transformation starts inside."
        link="/fitness#pricing"
        ctaText="Start 3 Days Trial"
        accentColor="#05AAE3"
      />
    </Template>
  );
}

export default Home;
